/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Actions/AccessTokenActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";

export interface IAccessTokenPayload {
    resourceTenantId: string;
    accessTokenKey: string;
}

export class AccessTokenActions extends ActionsHubBase {

    public static getKey(): string {
        return "k8s-res-access-token-actions";
    }

    public initialize(instanceId?: string) {
        this._getAccessToken = new Action<IAccessTokenPayload>();
    }

    public get getAccessToken(): Action<IAccessTokenPayload> {
        return this._getAccessToken;
    }

    private _getAccessToken: Action<IAccessTokenPayload>;
}
